<template>
  <section>
    <div class="form-content">
      <div class="clear">
        <el-col :span="10">
          <el-form-item label="申请单位">
            <el-input size="small" :disabled="true" v-model="userData.department.split('/')[0]"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="申请部门">
            <el-input size="small" :disabled="true" v-model="userData.childDept"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="申请人">
            <el-input size="small" :disabled="true" v-model="userData.name"></el-input>
          </el-form-item>
        </el-col>
      </div>

      <div class="clear">
        <el-col :span="12">
          <el-form-item label="申请日期">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="form.applyTime" type="date"
              placeholder="申请日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="出发时间">
            <el-time-picker size="small" v-model="form.setOutTime" value-format="HH:mm:ss" :picker-options="{ }" placeholder="任意时间点">
            </el-time-picker>
          </el-form-item>
        </el-col>
      </div>

      <div class="clear" v-if="carType=='1'">
        <el-col :span="12">
          <el-form-item label="派遣车辆信息">
            <el-select @change="forceUpdate" size="small" class="project-list-select" v-model="form.carId" filterable
              placeholder="请选择(可搜索车牌号)">
              <el-option v-for="item in carList" :key="item.id" :label="item.xh+' - '+item.plateNo+' - '+item.type"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="用车地点">
            <el-input size="small" placeholder="输入用车地点" v-model="form.address"></el-input>
          </el-form-item>
        </el-col>
      </div>
      <el-form-item label="用车事由">
        <el-input type="textarea" placeholder="申请事由及目的地" :autosize="{ minRows: 5, maxRows: 8}" size="small"
          v-model="form.reason"></el-input>
      </el-form-item>

    </div>
  </section>

</template>
<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  export default {
    props: ['formByFather', 'userData', 'useApplyType', 'carType'],
    computed: {
      ...mapState({
        contactSelectArr: state => state.main.contactSelectArr,
      })
    },
    data() {
      return {
        form: {},
        carList: [],

        userDeptId: "",
      }
    },
    created() {
      this.depId = this.userData.secDepIds.split(",")[0] / 1
      this.getCarLists()
    },
    mounted() {
      this.form = this.formByFather
    },
    methods: {
      // select刷新view
      forceUpdate(item) {
        this.$forceUpdate()
      },
      // 获取所有车辆
      getCarLists() {
        ajax.get('/car/list', {
          depId: this.depId
        }, (res) => {
          this.loading = false
          this.carList = res.vo.array
        })
      },
      // 返回form
      getFromData() {
        return this.form
      },
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
        this.selectLeader = [this.form.driver]
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/car/dispatch.vue